import React, { useState, useEffect, useRef } from "react";
import {  Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import Sidebar1 from "./sidebar/index";
import { TopNav } from "./navbar";

const DashboardLayout = () => {
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isScrolling] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const sidebarBackgroundCheck = pathname.split("/")[1];
  const [showSidebar, setShowSidebar] = useState(true);
  const isSettings =
    pathname.includes("account") || pathname.includes("create-link");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };


  const routesWithoutSidebar = ["/notification", "/create-link"];

  useEffect(() => {
    if (routesWithoutSidebar.includes(pathname)) {
      setShowSidebar(false);
    } else {
      setShowSidebar(true);
    }
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        handleCloseSidebar();
      }
    };

    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    if (
      [
        "cpas-dashboard",
        "resseler",
        "automations",
        "campaigns",
        
      ].includes(sidebarBackgroundCheck)
    ) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [sidebarBackgroundCheck]);


  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="mx-auto flex min-h-screen md:h-screen overflow-hidden">
      {/* Sidebar Toggle Button for Mobile */}
      {!sidebarOpen && (
        <div
          className={classNames(
            "md:flex gap-x-8 items-center inline  w-full  fixed py-4 md:bg-transparent z-10",
            {
              "bg-white opacity-95 z-30": isScrolling,
            }
          )}
        >
          <button
            className={classNames(
              "md:hidden relative left-4 p-2 rounded-full shadow-lg z-50"
            )}
            onClick={toggleSidebar}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 3.125H4.375C3.87772 3.125 3.40081 3.32254 3.04917 3.67417C2.69754 4.02581 2.5 4.50272 2.5 5V6.875V15C2.5 15.4973 2.69754 15.9742 3.04917 16.3258C3.40081 16.6775 3.87772 16.875 4.375 16.875H9M9 3.125H15.625C16.1223 3.125 16.5992 3.32254 16.9508 3.67417C17.3025 4.02581 17.5 4.50272 17.5 5V6.875V15C17.5 15.4973 17.3025 15.9742 16.9508 16.3258C16.5992 16.6775 16.1223 16.875 15.625 16.875H9M9 3.125V16.875M5 6.5H6.5M5 9.5H6.5"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          {isSettings && (
            <button className="md:hidden left-4">
              {/* <SettingsBack /> */}
            </button>
          )}
        </div>
      )}

      {/* Sidebar */}
      {showSidebar && (
        <aside
          ref={sidebarRef}
          className={classNames(
            "transition-all duration-300 fixed md:static z-40 mx-5 my-5 rounded-md  bg-white",
            {
              "w-[260px] left-0": sidebarOpen,
              "-left-full w-[58px]": !sidebarOpen, // hide it when closed
            }
          )}
          // style={{ height: "100vh" }}
        >
          <div ref={dropdownRef}>
            {sidebarOpen && (
            //   <button className="md:hidden" onClick={toggleSidebar}>
            //     <LogoIcon />
            //   </button>
            <></>
            )}
          </div>

          <Sidebar1 open={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        </aside>
      )}

      {/* Main Content */}

      <main className="flex-1 overflow-y-auto">
         
      <div className="min-h-full p-4">
              <TopNav />
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
